var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleLogo = function SvgGoogleLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "3 3 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-official-filled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/google-official"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8805 19.342C33.8805 18.3413 33.7918 17.3913 33.6398 16.4666H19.3265V22.1793H27.5218C27.1545 24.054 26.0778 25.6373 24.4818 26.714V30.514H29.3711C32.2338 27.8666 33.8805 23.9653 33.8805 19.342Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3276 34.2002C23.4316 34.2002 26.8631 32.832 29.3711 30.514L24.4818 26.714C23.1138 27.626 21.3796 28.1835 19.3276 28.1835C15.3629 28.1835 12.0062 25.5109 10.8029 21.9009H5.76156V25.8149C8.25689 30.7802 13.3869 34.2002 19.3276 34.2002Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8029 21.9009C10.4862 20.9889 10.3205 20.0136 10.3205 19.0003C10.3205 17.987 10.4978 17.0116 10.8018 16.0996V12.1856H5.76046C4.7218 14.2376 4.12646 16.543 4.12646 19.0003C4.12646 21.4576 4.72289 23.7629 5.76156 25.8149L10.8029 21.9009Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3276 9.81672C21.5696 9.81672 23.5709 10.5894 25.1542 12.0967L29.4862 7.76472C26.8642 5.30738 23.4316 3.80005 19.3276 3.80005C13.3869 3.80005 8.2558 7.22029 5.76046 12.1856L10.8018 16.0996C12.0051 12.4896 15.3629 9.81672 19.3276 9.81672Z",
    fill: "#EA4335"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-logo.47871cfa137970df304c4917b81a6edd.svg";